export default "__VITE_ASSET__Bm7kCdUc__"